import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.season.pagination');
import { OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wiz-portal-season-pagination',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.season.pagination/view.scss */
/* src/app/portal.season.pagination/view.scss: no such file or directory */`],
})
export class PortalSeasonPaginationComponent implements OnInit, OnChanges {
    @Input() current: any = 1;
    @Input() start: any = 1;
    @Input() end: any = 1;
    @Input() maxlength: any = 10;
    @Output() pageMove = new EventEmitter<number>();

    public list: Array<number> = [];

    public async ngOnInit() {
        this.Math = Math;
    }

    public async ngOnChanges() {
        this.list = [];
        for (let i = 0; i < this.maxlength; i++) {
            if (this.start + i > this.end) break;
            this.list.push(this.start + i);
        }
    }

    public move(page: number) {
        this.pageMove.emit(page);
    }
}

export default PortalSeasonPaginationComponent;